import {
	createFileRoute,
	FileRoutesByPath,
	ParsedLocation,
	redirect,
} from '@tanstack/react-router';

export const LOCAL_STORAGE_AUTH_KEY = 'graphweaver-auth';

export const resetLocalAuthKey = () => {
	localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY);
};

export const setLocalAuthKey = (token: string) => {
	localStorage.setItem(LOCAL_STORAGE_AUTH_KEY, token);
};

export const isAuthenticated = () => {
	return Boolean(localStorage.getItem(LOCAL_STORAGE_AUTH_KEY));
};

type TFilePath = keyof FileRoutesByPath;

type FileRouteResult<T extends TFilePath> = ReturnType<typeof createFileRoute<T>>;
type FileRouteParams<T extends TFilePath> = Parameters<FileRouteResult<T>>[0];

export const createAuthenticatedRoute = <T extends TFilePath>(path: T) => {
	const fileRoute = createFileRoute(path);

	const beforeLoad = async ({ location }: { location: ParsedLocation }) => {
		if (!isAuthenticated()) {
			throw redirect({
				to: '/auth/login',
				search: {
					redirect: location.href,
				},
			});
		}
	};

	return (params: FileRouteParams<T>) => {
		return fileRoute({
			beforeLoad,
			...params,
		});
	};
};
